/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit ResetPasswordAction/view.blocks to change it.
import * as fromDesignTokens from 'Simple/DesignTokens'
import * as fromFlow from 'Simple/Flow'
import React from 'react'
import TysiaTextLink from 'DesignSystem/TysiaTextLink/index'



/** @type {import('Simple/types.js').View} */
export default function ResetPasswordAction({
  children,
  viewPath = "/App/Auth/SignIn/Credentials/ResetPasswordAction"
  
}) {
  let flow = fromFlow.useFlow()
  let setFlowTo = fromFlow.useSetFlowTo(viewPath)
let dtColorsNeutral700 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.700'
        })
  return (<React.Fragment
>
<TysiaTextLink
  viewPath={`${viewPath}/TysiaTextLink`}
 size="normal"
 color={dtColorsNeutral700}
 text="Forgot password?"
 onClick={() => setFlowTo(fromFlow.normalizePath(viewPath, '../../../ResetPassword'))}
 isSelected={flow.has(fromFlow.normalizePath(viewPath, '../../../ResetPassword'))}
/>
{children}
</React.Fragment>)
}